import en from "./en";
export { en };


// WEBPACK FOOTER //
// ./src/i18n/locales/index.js